import React from 'react';

import ChartAxis from '../../../../library/chart-axis/chart-axis';
import TireComparisonLine from '../tire-comparison-line/tire-comparison-line';

import './tire-comparison-chart.scss';

interface TireComparisonChartProps {
  currentDistance: number;
  currentWornDistance?: number;
  hideRecommended?: boolean;
  isDry?: boolean;
  isLT?: boolean;
  isWet?: boolean;
  recommendedDistance: number;
  recommendedWornDistance?: number;
}

const passengerMinValue = 0;
const passengerMaxValue = 250;
const lightTruckMinValue = 100;
const lightTruckMaxValue = 350;

function TireComparisonChart(props: TireComparisonChartProps) {
  const {
    currentDistance = 0,
    currentWornDistance = 0,
    hideRecommended = false,
    isDry = false,
    isLT = false,
    isWet = false,
    recommendedDistance = 0,
    recommendedWornDistance = 0
  } = props;

  const max = isLT ? lightTruckMaxValue : passengerMaxValue;
  const min = isLT ? lightTruckMinValue : passengerMinValue;

  return (
    <div styleName="container">
      <div styleName="speed-indicator">
        <span>60</span>
        <span>MPH</span>
      </div>

      <div styleName="bars">
        <TireComparisonLine
          comparisonDistance={isWet ? currentWornDistance : void 0}
          distance={currentDistance}
          hideRecommended={hideRecommended}
          isDry={isDry}
          isWet={isWet}
          max={max}
          min={min}
        />
        {!hideRecommended && (
          <TireComparisonLine
            comparisonDistance={isWet ? recommendedWornDistance : void 0}
            distance={recommendedDistance}
            max={max}
            min={min}
            styleName="comparison-line"
          />
        )}
        <ChartAxis
          increment={50}
          max={max}
          min={min}
          shouldTuckTickLabels
          tickSuffix="’"
        />
      </div>
    </div>
  );
}

export default TireComparisonChart;
